
import React from 'react'
import logoMUS from '../assets/Group.png'
import logoCFN from '../assets/CFN-xs.png'
import ButtonDrawer from './ButtonDrawer'
import { useSelector } from 'react-redux'
import { AppBar, Box, Toolbar, styled } from '@mui/material'


const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between"
});

const CODEMP_MUS = [2, 52];

const NavBarPlanes = () => {

  const { paramsMus } = useSelector((state) => state.firstStep);
  const { codemp } = useSelector(state => state.adminReducer.login);

  return (
    <>
      <AppBar position='sticky' sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
        <StyledToolbar>
          {
            <Box sx={{ display: "block", visibility: (codemp === 52 || codemp === 51) ? 'visible' : 'hidden' }} >
              <div className={codemp === 52 ? 'mus-strong' : codemp === 51 ? 'cfn-strong' : ''}>
                <img style={{ paddingLeft: '30px' }} alt="" /><strong>TEST</strong>
              </div>
            </Box>
          }
          <Box>
            <img style={{ width: (codemp === 1 || codemp === 51) ? '50%' : '', marginLeft: (codemp === 1 || codemp === 51) ? '65px' : codemp === 52 ? '12px' : '' }} src={CODEMP_MUS.includes(codemp) ? logoMUS : logoCFN} alt="logo" />
          </Box>
          <Box paddingRight={'30px'} sx={{ display: "block" }}>
            <ButtonDrawer codpmpol={paramsMus.nro} />
          </Box>
        </StyledToolbar>
      </AppBar>
    </>
  )
}

export default NavBarPlanes;


